// import  { useState } from "react";
// import { useTranslation } from "react-i18next";
// import { useNavigate } from "react-router-dom";
import hamburger from "../../assets/images/hamburger-menu.svg";
import useWindowDimension from "../hooks/useWindowDimension";

interface HeaderProps {
  t: any;
  toggleMenuCallback: () => void;
  showRightSidebar: any;
  toggleRightSidebar: () => void;
}

function Header(props: HeaderProps) {
  // const [logoutModal, setLogoutModal] = useState(false);
  // const { t } = useTranslation();
  // const navigate = useNavigate();

  const toggleMenu = () => {
    props.toggleMenuCallback();
  };

  // const handleLogout = () => {
  //   setLogoutModal(true);
    // localStorage.clear();
    // navigate("/");
  // };

  // const logoutFunction = () => {
  //   setLogoutModal(false);
  //   localStorage.clear();
  //   navigate("/");
  // };

  // const closeLogoutModel = () => {
  //   setLogoutModal(false);
  // };
  const dimensions = useWindowDimension();
  return (
    <>
      <header id="page-topbar">
        <div className="navbar-header">
        <div className="d-flex smallLogo justify-content-center">
          {dimensions.width < 1281 &&
            <div
            onClick={toggleMenu}
            >
              <img src={hamburger} alt="" />
            </div>}
        </div>
        <div className="d-flex ">
          {/* <ProfileMenu handleLogout={handleLogout} /> */}
        </div>
        </div>
      </header>

      {/* <ConfirmationModal
        className={"delete-modal logout"}
        iconCricle={"icon-cricle-delete"}
        modalTitle={t("LOGOUT")}
        modalDescription={t("ARE_YOU_SURE_YOU_WANT_TO_LOGOUT_FROM_THE_APP")}
        isUnderline={false}
        showModal={logoutModal}
        leftBtnTitle={t("CONFIRM")}
        isModelIcon={true}
        icons={"Icon-3"}
        leftBtnClass={"btn btn-danger"}
        isFirstButton={true}
        isSecondButton={true}
        rightBtnClass="btn btn-cancel"
        rightBtnTitle={t("CANCEL")}
        onProcced={logoutFunction}
        rightButtonClick={closeLogoutModel}
        isBold={false}
        leftdisabled={false}
        rightdisabled={false}
        onHide={closeLogoutModel}
        loaderButtonShow={false}
        modalContent={true} messagebold={''}
        closeModelIcon={() => {
          setLogoutModal(false);
        }} /> */}
    </>
  );
}

export default Header;
